import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/captive-login-type/",

        async getLocalTree(id) {
          const url = this.url(`${id}/filtro/open/local`)
          return await Vue.http.get(url)
        },

        async list() {
            const url = this.url();
            return await Vue.http.get(url);
        },

        async create(payload) {
            const url = this.url();
            return await Vue.http.post(url, payload);
        },
        async edit(payload) {
            const url = this.url(`${payload.id}`);
            return await  Vue.http.put(url, payload)
        },
        async delete({id}) {
            const url = this.url(`${id}`);
            return await Vue.http.delete(url);
        }

    },
    base
)
